import { css } from 'styled-components';

export const IconMarginLeftCss = css`
  margin-left: 0.5rem;
`;
